import { contentfulImageUrl } from '@telialt/utils/src/Contentful/contentfulImageUrl';

import { BlogSectionType } from '../../../models/Content';

export const transformSectionVideo = (content: BlogSectionType) => {
    return {
        poster: contentfulImageUrl(content.fields.videoPoster?.fields?.file?.url),
        video: content.fields.video?.fields?.file?.url,
        contentType: content.fields.video?.fields?.file?.contentType,
        subtitles: content.fields.captions?.fields?.file?.url,
    };
};
